import actionTypes from './actionTypes'
import config from '../../../config/config'

const {
  REQUEST_UPDATEIPADDRESS,
  RECEIVE_UPDATEIPADDRESS,
  ERROR_UPDATEIPADDRESS
} = actionTypes

export function updateIpAddresses(token, domainId, ipAddresses) {
  return function (dispatch) {
    dispatch({type: REQUEST_UPDATEIPADDRESS})

    const payload = {
      whitelisted_ip_addresses: ipAddresses
    }

    return fetch(`${config.URI}/api/v1/fvdomains/${domainId}/update_ip_addresses`, {
      method: 'post',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && (res.status === 'success')) {
          dispatch({type: RECEIVE_UPDATEIPADDRESS})
        } else if (res.errors) {
          dispatch({type: ERROR_UPDATEIPADDRESS})
          console.error(res.errors)
          return
        }
      })
      .catch(e => {
        console.error(e)

      })
  }
}




// WEBPACK FOOTER //
// src/routes/ManageIpAddress/actions/index.js